var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { staticClass: "noImprimir" },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-app-bar",
                { staticClass: "appbarPrint", attrs: { absolute: "" } },
                [
                  _c("v-toolbar-title", [
                    _vm._v(" Autorización de salida de equipos ")
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-5",
                      attrs: { icon: "" },
                      on: {
                        click: function($event) {
                          return _vm.print()
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { color: "white" } }, [
                        _vm._v("mdi-printer")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "appbarSpace" },
        [
          _c("v-col", { attrs: { cols: "12" } }, [
            _c("table", [
              _c("tbody", [
                _c("tr", [
                  _c(
                    "td",
                    { staticClass: "centerItem p25 b-white text-left py-3" },
                    [
                      _c("v-img", {
                        staticClass: "logo",
                        attrs: {
                          src: require("../../../assets/tecnologicagente.jpg"),
                          alt: "Logo Daycohost"
                        }
                      })
                    ],
                    1
                  ),
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("h2", [
                      _c("b", [_vm._v("AUTORIZACIÓN DE SALIDA DE EQUIPOS")])
                    ])
                  ]),
                  _c("td", { staticClass: "p25 b-white" }, [
                    _c("div", { staticClass: "text-right" }, [
                      _vm._v(_vm._s(_vm.date))
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "b-white py-3" }, [
                    _c("div", { staticClass: "text-left" }, [
                      _c("b", [_vm._v("SEDE")]),
                      _vm._v(": " + _vm._s(_vm.location))
                    ])
                  ])
                ]),
                _c("tr", [
                  _c(
                    "td",
                    {
                      staticClass: "centerItem p100 b-white py-3",
                      attrs: { colspan: "3" }
                    },
                    [
                      _c("div", [
                        _vm._v(
                          " Por medio del presente autorizamos al Sr. (a) "
                        ),
                        _c("b", [_vm._v(_vm._s(_vm.authorizedContact))]),
                        _vm._v(
                          " a retirar de nuestras instalaciones el (los) equipo (s) que se describen a continuación propiedad de: "
                        ),
                        _c("b", [_vm._v(_vm._s(_vm.owner))])
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _c("table", { staticClass: "my-3" }, [
              _c(
                "tbody",
                [
                  _c("tr", [
                    _c("td", { staticClass: "centerItem p5" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("ITEM")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p15" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("DESCRIPCIÓN")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p5" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("CANTIDAD")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p10" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("MARCA")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p10" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("MODELO")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p10" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("SERIAL")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p10" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("DESTINO")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p10" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("MOTIVO")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p10" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("TIPO DE SALIDA")])
                      ])
                    ]),
                    _c("td", { staticClass: "centerItem p10" }, [
                      _c("div", { staticClass: "py-2" }, [
                        _c("b", [_vm._v("CONCEPTO")])
                      ])
                    ])
                  ]),
                  _vm._l(_vm.equipments, function(item, k) {
                    return _c("tr", { key: k }, [
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(k + 1) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.description) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.quantity) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.brand) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.model) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.serial) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.destination) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.motive) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.lengthOfTransfer) + " ")
                        ])
                      ]),
                      _c("td", { staticClass: "centerItem" }, [
                        _c("div", { staticClass: "py-2" }, [
                          _vm._v(" " + _vm._s(item.concept) + " ")
                        ])
                      ])
                    ])
                  })
                ],
                2
              )
            ]),
            _c("table", { staticClass: "my-2" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white py-2" }, [
                    _c("div", [_c("b", [_vm._v("GESTIONADO POR:")])])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white py-2" }, [
                    _c("div", [
                      _c("b", [_vm._v("AUTORIZADO POR VP DE SERVICIOS: ")])
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c("div", { staticClass: "fs-14" }, [
                        _vm._v(_vm._s(_vm.managerName))
                      ]),
                      _c("div", [_vm._v(_vm._s(_vm.managerJob))])
                    ])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", { staticClass: "fs-14" }, [
                      _vm._v(_vm._s(_vm.vpServicesSupervisor))
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "p50 mx-auto mt-12" },
                        [_c("v-divider")],
                        1
                      ),
                      _vm._v(" FIRMA ")
                    ])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "p50 mx-auto mt-10" },
                        [_c("v-divider")],
                        1
                      ),
                      _vm._v(" FIRMA ")
                    ])
                  ])
                ])
              ])
            ]),
            _c("table", { staticClass: "my-2" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white py-2" }, [
                    _c("div", [
                      _c("b", [_vm._v("AUTORIZADO POR VP DE FINANZAS:")])
                    ])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white py-2" }, [
                    _c("div", [_c("b", [_vm._v("RECIBIDO POR CLIENTE:")])])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c("div", { staticClass: "fs-14" }, [
                        _vm._v(_vm._s(_vm.VPFinancesName))
                      ])
                    ])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c("div", [_vm._v(_vm._s(_vm.customerName))]),
                      _c("div", [_vm._v(_vm._s(_vm.responsiblePerson))]),
                      _c("div", [
                        _c("b", [_vm._v("CI")]),
                        _vm._v(": " + _vm._s(_vm.customerCI))
                      ]),
                      _c("div", [
                        _c("b", [_vm._v("Telf")]),
                        _vm._v(": " + _vm._s(_vm.customerPhone))
                      ])
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "p50 mx-auto mt-10" },
                        [_c("v-divider")],
                        1
                      ),
                      _vm._v(" FIRMA ")
                    ])
                  ]),
                  _c("td", { staticClass: "centerItem p50 b-white" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "p50 mx-auto mt-12" },
                        [_c("v-divider")],
                        1
                      ),
                      _vm._v(" FIRMA ")
                    ])
                  ])
                ])
              ])
            ]),
            _c("table", { staticClass: "my-2" }, [
              _c("tbody", [
                _c("tr", [
                  _c("td", { staticClass: "centerItem p100 b-white py-2" }, [
                    _c("div", [
                      _c("b", [_vm._v("AUTORIZADO POR PRESIDENCIA EJECUTIVA:")])
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "centerItem p100 b-white" }, [
                    _c("div", { staticClass: "fs-14" }, [
                      _vm._v(_vm._s(_vm.presidentName))
                    ])
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "centerItem b-white" }, [
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "p25 mx-auto mt-10" },
                        [_c("v-divider")],
                        1
                      ),
                      _vm._v(" FIRMA ")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }